import { useSearchParams } from 'next/navigation'
import { Primary as DSCtaButton } from '@cinch-labs/design-system'

import styles from './cta-button.module.css'
import { appendUrlParams } from '../../utils'

interface CtaButtonProps {
  body: string
  link: string
}

export const CtaButton: React.FC<CtaButtonProps> = ({ body, link }) => {
  const searchParams = useSearchParams()

  const url = appendUrlParams({ link, searchParams })

  return (
    <div className={styles.vapsCtaButtonContainer}>
      <DSCtaButton element="a" href={url} isFullWidth>
        {body}
      </DSCtaButton>
    </div>
  )
}
